import { createTheme } from '@mui/material';

export const customTheme = createTheme({
  palette: {
    primary: { main: 'rgb(101,183,65)', contrastText: '#fff' },
    background: { default: 'rgb(249,255,244)' },
    action: { hover: 'rgb(249,255,244)', selected: 'rgb(239,253,219)' },
    text: { primary: '#263238' },
  },
  typography: {
    fontFamily: `ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
  },
});
